import Vue from 'vue';
import Router from 'vue-router';

// import http from './utils/axios';

// let instance = http();
Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    name: 'login',
    component: () => import('./view/login'),
    meta: {
      title: '登录'
    }

  },
  {
    name: 'index',
    component: () => import('./view/index'),
    meta: {
      title: '首页'
    }

  },
  {
    name: 'search',
    component: () => import('./view/search'),
    meta: {
      title: '库存搜索'
    }
  },
  {
    name: 'logout',
    component: () => import('./view/logout'),
    meta: {
      title: '个人中心'
    }

  },
  {
    name: 'purchase',
    component: () => import('./view/purchase'),
    meta: {
      title: '采购入库'
    }
  },
  {
    name: 'consuming',
    component: () => import('./view/consuming'),
    meta: {
      title: '领用出库'
    }
  },
  {
    name: 'gift',
    component: () => import('./view/gift'),
    meta: {
      title: '赠品入库'
    }
  },
  {
    name: 'sale',
    component: () => import('./view/sale'),
    meta: {
      title: '销售出库'
    }
  },
  {
    name: 'paw',
    component: () => import('./view/paw'),
    meta: {
      title: '采购入库'
    }
  },
  {
    name:'pwalist',
    component:()=>import('./view/pwalist'),
    meta:{
      title:'影像中心列表'
    }
  },
  {
    name:'orderlist',
    component:()=>import('./view/orderlist'),
    meta:{
      title:'客户列表'
    }
  },
  {
    name:'customerlist',
    component:()=>import('./view/customerlist'),
    meta:{
      title:'订单列表'
    }
  },
  {
    name:'stockinfo',
    component:()=>import('./view/stockinfo'),
    meta:{
      title:'库存列表'
    }
  },
  {
    name:'consumables',
    component:()=>import('./view/consumables'),
    meta:{
      title:'耗材列表'
    }
  },
  {
    name:'warehouse',
    component:()=>import('./view/warehouse'),
    meta:{
      title:'选择科室'
    }
  },
  {
    name:'record',
    component:()=>import('./view/record'),
    meta:{
      title:'出入库记录'
    }
  },
  {
    name:'recorddetail',
    component:()=>import('./view/recorddetail'),
    meta:{
      title:'出入库详情'
    }
  },
  {
    name:'recordcheck',
    component:()=>import('./view/recordcheck'),
    meta:{
      title:'出入库审核'
    }
  },
  {
    name:'recorddetailcheck',
    component:()=>import('./view/recorddetailcheck'),
    meta:{
      title:'出入库审核详情'
    }
  },
  {
    name: 'inventory',
    component: () => import('./view/inventory'),
    meta: {
      title: '盘点记录'
    }
  },
  {
    name: 'inventorydetail',
    component: () => import('./view/inventorydetail'),
    meta: {
      title: '盘点详情'
    }
  },
  {
    name: 'stockrecord',
    component: () => import('./view/stockrecord'),
    meta: {
      title: '收发存查询'
    }
  },
  {
    name: 'salesreturn',
    component: () => import('./view/salesreturn'),
    meta: {
      title: '退货管理'
    }
  },
  {
    name: 'addsalesreturn',
    component: () => import('./view/addsalesreturn'),
    meta: {
      title: '新建退货单'
    }
  },
  {
    name: 'returnorderlist',
    component: () => import('./view/returnorderlist'),
    meta: {
      title: '退货订单列表'
    }
  },
  {
    name: 'returnorderdetail',
    component: () => import('./view/returnorderdetail'),
    meta: {
      title: '退货订单明细'
    }
  },
  {
    name: 'salesreturndetail',
    component: () => import('./view/salesreturndetail'),
    meta: {
      title: '退货单详情'
    }
  },
  {
    name: 'allot',
    component: () => import('./view/allot'),
    meta: {
      title: '调拨管理'
    }
  },
  {
    name: 'addallot',
    component: () => import('./view/addallot'),
    meta: {
      title: '新建调拨单'
    }
  },
  {
    name: 'allotdetail',
    component: () => import('./view/allotdetail'),
    meta: {
      title: '调拨单详情'
    }
  },
  {
    name: 'stockdetail',
    component: () => import('./view/stockdetail'),
    meta: {
      title: '库存详情'
    }
  },
  {
    name: 'choiceproject',
    component: () => import('./view/choiceproject'),
    meta: {
      title: '库存详情'
    }
  },
  {
    name: 'scrapped',
    component: () => import('./view/scrapped'),
    meta: {
      title: '报损出库'
    }
  },
  {
    name: 'test',
    component: () => import('./view/test'),
    meta: {
      title: '测试'
    }
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  if (to.path === '/login') {
    if (from.path === '/logout') {
      let timestamp = (new Date()).valueOf()
      window.location.href = '/index.html?t=' + timestamp + '#' + to.fullPath
      //window.location.href = '/index.html?phone=17601023150'  + '#' + to.fullPath
    }

    next();
  } else {
    let token = localStorage.getItem('userToken');
    if (token === null || token === '') {
      next('/login');
    } else {
      next();
    }
  }
});

export {
  router
};

